import {
  IDailySheetReportModalProps,
  IRoentgenReportModalProps,
} from "../types/modal";

import { useAppDispatch } from "../hooks/redux";
import { closeModalById } from "../features/modals";

import moment from "moment";
import { useFormik } from "formik";

import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  Stack,
  DialogContent,
} from "@mui/material";

import createDailySheetReportSchema from "../schemas/createDailySheetReport";
import axios from "axios";
import { LoadingButton } from "@mui/lab";
import { MonthCalendar, DateCalendar } from "@mui/x-date-pickers";
import { Controller, useForm } from "react-hook-form";
import { useCallback, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";

const DailySheetReportModal: React.FunctionComponent<
  IDailySheetReportModalProps
> = ({ id, clinic, callback }) => {
  const dispatch = useAppDispatch();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      clinic,
      date: moment().toDate(),
    },

    // @ts-ignore
    resolver: yupResolver(createDailySheetReportSchema),
  });

  const onSubmit = handleSubmit((values) => {
    setIsSubmitting(true);

    axios
      .post<{ _id: string }>("/daily-sheets", values)
      .then((response) => {
        setIsSubmitting(false);
        handleClose();
        callback(response.data._id);
      })
      .catch((err) => {
        console.log("err:", err);
        setIsSubmitting(false);
      });
  });

  // const onSubmit = useCallback(async (values: yup.InferType<typeof schema>) => {
  //   // try {
  //   //   setIsLoading(true);

  //   //   await axios.post(
  //   //     `/clinics/${clinic}/warehouse/take/${material._id}`,
  //   //     values
  //   //   );

  //   //   toast.success("Materiāli paņemti");

  //   //   setIsLoading(false);

  //   //   callback();
  //   //   handleClose();
  //   // } catch (error) {
  //   //   toast.error("Neizdevās paņemt materiālus");
  //   // }
  // }, []);

  // const { values, setFieldValue, handleSubmit, isSubmitting } =
  //   useFormik<DailySheetReportBase>({
  //     initialValues: { clinic, date: moment().toDate() },
  //     onSubmit: (values, { setSubmitting }) => {
  //       setSubmitting(true);
  //       axios
  //         .post<{ _id: string }>("/daily-sheets", values)
  //         .then((response) => {
  //           setSubmitting(false);
  //           handleClose();
  //           callback(response.data._id);
  //         })
  //         .catch((err) => {
  //           console.log("err:", err);
  //           setSubmitting(false);
  //         });
  //     },
  //     validationSchema: createRoentgenReportSchema,
  //   });

  const handleClose = () => {
    dispatch(closeModalById(id));
  };

  return (
    <Dialog fullWidth={true} maxWidth="xs" open={true} onClose={handleClose}>
      <form onSubmit={onSubmit}>
        <DialogTitle>Izveidot dienas lapu</DialogTitle>
        <DialogContent style={{ paddingTop: 20 }}>
          <Stack alignItems="center">
            <Controller
              name="date"
              control={control}
              render={({ field }) => (
                <DateCalendar
                  value={moment(field.value)}
                  maxDate={moment()}
                  onChange={field.onChange}
                />
              )}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Atcelt</Button>
          <LoadingButton
            loading={isSubmitting}
            type="submit"
            variant="contained"
          >
            Izveidot
          </LoadingButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default DailySheetReportModal;
